export default __webpack_public_path__ + "static/media/drupal.b21ba40a.svg";